module.exports = __webpack_public_path__ + "img/fillter_icon.496a2e77.svg";